import { Assignment, Check, MailOutline } from "@material-ui/icons";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/Commission/create.js";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import PropTypes from "prop-types";
import { bookingApi, paymentApi } from "functions/apis";
import CustomInput from "components/CustomInput/CustomInput.js";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select
} from "@material-ui/core";
import ReactTable from "react-table";
import { formatTripDate } from "functions/Helper";
import { formatDateTime } from "functions/Helper";
import { formatDate } from "functions/Helper";
import { GetPaymentProcessorDescription } from "enums/PaymentProcessor";
import { token } from "functions/Helper";
import { toast, ToastContainer } from "react-toastify";

const useStyles = makeStyles(styles);

export default function SendTravelItinerary(props) {
  const sortOptionsList = [
    "IDENTIFICATION_NO_ASC",
    "IDENTIFICATION_NO_DESC",
    "IDENTIFICATION_FULLNAME_ASC",
    "IDENTIFICATION_FULLNAME_DESC"
  ];
  const [state, setState] = useState(null);
  const [payment, setPayment] = useState(null);
  const [totalPaxes, setTotalPaxes] = useState(0);
  const [pages, setPages] = React.useState(0);
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [filter, setFilter] = React.useState({
    searchString: null,
    sort: null
  });
  const [passengerData, setPassengerData] = useState([]);
  const [loading, setLoading] = React.useState(false);

  const [disabled, setDisabled] = React.useState(false);

  const { id } = useParams();

  const abortControllerRef = React.useRef(new AbortController());
  const onlineBookingSubmit = new AbortController();
  const deleteOnlineBookingData = new AbortController();

  useEffect(() => {
    return () => {
      onlineBookingSubmit.abort();
      deleteOnlineBookingData.abort();
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    bookingApi
      .get("OnlineBookings/" + id + "/Details", {
        signal: abortControllerRef.current.signal,
        params: {
          filter: filter,
          pagination: pagination,
          bookingID: id
        }
      })
      .then(data => {
        setPassengerData(data.records);
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
        setTotalPaxes(data.totalRecords);
      })
      .catch(error => console.log(error))
      .finally(() => setLoading(false));
  }, [filter, pagination]);

  useEffect(() => {
    bookingApi
      .get("OnlineBookings/" + id, {
        signal: abortControllerRef.current.signal
      })
      .then(data => {
        setState(data);
        if (
          data.paymentReferenceID !== null &&
          (token["payment.payments.read"] === "allowed" ||
            token.is_admin === "True")
        )
          paymentApi
            .get("Payments/" + data.paymentReferenceID, {
              signal: abortControllerRef.current.signal
            })
            .then(data => setPayment(data))
            .catch(error => console.log(error));
      })
      .catch(error => console.log(error));
    return () => abortControllerRef.current.abort();
  }, []);

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  const handleSortOptionsChanged = e => {
    setFilter({ ...filter, sort: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);

    const resolveFromBookingApi = new Promise((resolve, reject) => {
      bookingApi
        .post(
          `OnlineBookings/${id}/SendTravelItinerary`,
          { id },
          {
            signal: onlineBookingSubmit.signal
          }
        )
        .then(() => {
          resolve({ isSuccess: true });
        })
        .catch(error => {
          reject({ isSuccess: false, error });
        });
    });

    toast
      .promise(resolveFromBookingApi, {
        pending: "...Submitting data",
        success: {
          render({ data }) {
            if (data.isSuccess) {
              return `Success submit data`;
            } else {
              return `Error submit data: ${JSON.stringify(
                data.error?.response.data.title
              )}`;
            }
          }
        },
        error: {
          render({ data }) {
            return `Error submit data: ${JSON.stringify(
              data.error?.response.data.title
            )}`;
          }
        }
      })
      .then(resp => {
        if (resp?.isSuccess) {
          props.history.goBack();
        }
      })
      .finally(() => {
        setDisabled(false);
      });
  };

  const classes = useStyles();

  return (
    <GridContainer>
      {state !== null && (
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>SEND TRAVEL ITINERARY</h4>
            </CardHeader>
            <CardBody>
              <form onSubmit={handleSubmit}>
                <Button onClick={() => props.history.goBack()} value="Back">
                  BACK
                </Button>
                <Button
                  disabled={disabled}
                  color="rose"
                  type="submit"
                  value="Submit"
                >
                  Send Itinerary
                </Button>
              </form>
              <GridContainer>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="No"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.no ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Confirmation Code"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.confirmationCode ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Transaction Time"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: formatDateTime(
                        new Date(state.transactionTime + "Z")
                      )
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Username"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.user.name ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Email"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.user.email ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Contact Number"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.user.contactNumber ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Contact Name"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.contactName ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Email"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.email ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Phone Number"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.phoneNumber ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Departure Route"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.departureCoreApiTrip?.route?.name ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Departure Date"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: formatTripDate(state.departureCoreApiTrip.date)
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Departure Time"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.departureCoreApiTrip.time ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={12}>
                  <FormControlLabel
                    disabled
                    control={
                      <Checkbox
                        checked={state.isRoundTrip}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot,
                          disabled: true
                        }}
                      />
                    }
                    classes={{
                      label: classes.label,
                      root: classes.labelRoot
                    }}
                    label="Is Round Trip"
                  />
                </GridItem>
                {state.isRoundTrip && (
                  <>
                    <GridItem xs={12} md={12}>
                      <FormControlLabel
                        disabled
                        control={
                          <Checkbox
                            checked={state.isReturnTripOpen}
                            checkedIcon={
                              <Check className={classes.checkedIcon} />
                            }
                            icon={<Check className={classes.uncheckedIcon} />}
                            classes={{
                              checked: classes.checked,
                              root: classes.checkRoot,
                              disabled: true
                            }}
                          />
                        }
                        classes={{
                          label: classes.label,
                          root: classes.labelRoot
                        }}
                        label="Is Return Trip Open"
                      />
                    </GridItem>
                    {!state.isReturnTripOpen && (
                      <>
                        <GridItem xs={12} md={4}>
                          <CustomInput
                            disabled
                            labelText="Return Route"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: true,
                              value: state.returnCoreApiTrip.route.name ?? ""
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} md={4}>
                          <CustomInput
                            disabled
                            labelText="Return Date"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: true,
                              value: formatTripDate(
                                state.returnCoreApiTrip.date
                              )
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} md={4}>
                          <CustomInput
                            disabled
                            labelText="Return Time"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: true,
                              value: state.returnCoreApiTrip.time ?? ""
                            }}
                          />
                        </GridItem>
                      </>
                    )}
                  </>
                )}
                <GridItem xs={12} md={12}>
                  <CustomInput
                    disabled
                    labelText="Total Pax"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: totalPaxes
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={12}>
                  <CustomInput
                    disabled
                    labelText="Promo Code"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.onlineBookingPromoCode?.promoCode ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Free Reschedule Times"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.freeRescheduleTimes ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Departure Reschedule Count"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.departureRescheduleCount ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Return Reschedule Count"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.returnRescheduleCount ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={2}>
                  <CustomInput
                    disabled
                    labelText="Currency"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.currency?.code ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={2}>
                  <CustomInput
                    disabled
                    labelText="Total"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.total ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={2}>
                  <CustomInput
                    disabled
                    labelText="Promo Code Discount"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.promoCodeDiscount ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={2}>
                  <CustomInput
                    disabled
                    labelText="Voucher Amount"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.voucherAmount ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={2}>
                  <CustomInput
                    disabled
                    labelText="Flexi Trip Add On"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.RescheduleAddOnFee ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={2}>
                  <CustomInput
                    disabled
                    labelText="Grand Total"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.grandTotal ?? ""
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      )}
      {payment !== null && (
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Payment Information</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Created At"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: formatDateTime(new Date(payment.createdAt + "Z"))
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Processor"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: GetPaymentProcessorDescription(payment.processor)
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Processor Transaction Id"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: payment.processorTransactionId
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      )}
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Passengers</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} md={12}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel
                    htmlFor="selCurrency"
                    className={classes.selectLabel}
                  >
                    SORT BY
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={filter.sort ?? ""}
                    onChange={handleSortOptionsChanged}
                  >
                    {sortOptionsList.map(record => {
                      return (
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value={record}
                          key={record}
                        >
                          <p>{record}</p>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={12}>
                <CustomInput
                  labelText="Search"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleSearchStringChanged,
                    value: filter.searchString ?? ""
                  }}
                />
              </GridItem>
            </GridContainer>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page =>
                setPagination({
                  pageIndex: page + 1,
                  pageSize: pagination.pageSize
                })
              }
              onPageSizeChange={(pageSize, page) => {
                setPagination({ pageSize: pageSize, pageIndex: page + 1 });
              }}
              loading={loading}
              data={passengerData}
              filterable={false}
              columns={[
                {
                  id: "no",
                  Header: "No",
                  accessor: d => d.identification.no
                },
                {
                  id: "fullName",
                  Header: "Full Name",
                  accessor: d => d.identification.fullName
                },
                {
                  id: "nationality",
                  Header: "Nationality",
                  accessor: d => d.identification.nationality.name
                },
                {
                  id: "issuanceCountry",
                  Header: "Issuance Country",
                  accessor: d => d.identification.issuanceCountry.name
                },
                {
                  id: "dateOfBirth",
                  Header: "Date of Birth",
                  accessor: d =>
                    formatDate(new Date(d.identification.dateOfBirth))
                },
                {
                  id: "issueDate",
                  Header: "Issue Date",
                  accessor: d =>
                    formatDate(new Date(d.identification.issueDate))
                },
                {
                  id: "expiryDate",
                  Header: "Expiry Date",
                  accessor: d =>
                    formatDate(new Date(d.identification.expiryDate))
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
      <ToastContainer theme="light" />
    </GridContainer>
  );
}

SendTravelItinerary.propTypes = {
  history: PropTypes.object
};
